import { useDispatch, useSelector } from "react-redux";
import VendorDetail from "./VendorDetail"
import { getVendorDetails } from "Store/Organization/VendorDetails/VendorDetailsAction";
import { useEffect, useState } from "react";
import { setBulkOrderFleetHeader } from "Store/Component/PurchaseBulkOrder/PurchaseBulkOrderAction";

const VendorDetailContainer = (props?: any) => {
  const dispatch = useDispatch();
  const isNextClicked = props?.isNextClicked;
  const purchaseOrderStepperData = props?.purchaseOrderStepperData;
  const setIsButtondisable = props?.setIsButtondisable;
  const isButtonDisable = props?.isButtonDisable;
  const errors = props?.errors
  const hasValidVendorDetails = props?.hasValidVendorDetails;
  const {
    vendorDetails,
    bulkOrderFleetDetails
  }: any = useSelector((state: any) => ({
    vendorDetails: state.VendorDetailsReducer.vendorDropDownList,
    bulkOrderFleetDetails: state.PurchaseBulkOrderReducer.bulkOrderFleetDetails
  }));

  const [vendorSearchText, setVendorSearchText] = useState<string>("");
  const [vendorDropdownList, setVendorDropdownList] = useState<any>([]);
  const [vendor, setVendor] = useState<any>({});

  useEffect(() => {
    if (purchaseOrderStepperData?.vendorDetails?.vendorAbNumber) {
      const item = props?.purchaseOrderStepperData?.vendorDetails;
      setVendor({ text: item.vendorName, value: item.vendorName, label: item.vendorAbNumber + "-" + item.vendorName, key: item.vendorName, ...item });
    }
    const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
    let changedVendorDetails = bulkOrderFleetDetailsTemp?.find((orderItem?: any) => orderItem?.orderDetailId == purchaseOrderStepperData?.orderDetailId)
    let isValidVendorDetails = hasValidVendorDetails(changedVendorDetails ?? {})
    if (isValidVendorDetails) {
      setIsButtondisable(false);
    }else{
      setIsButtondisable(true);
    }
  }, [purchaseOrderStepperData])

  useEffect(() => {
    ///Modified dropDown values as required
    const list = vendorDetails?.map((item: any) =>
      ({ text: item.alphaName, value: item.alphaName, label: item.abnumber + "-" + item.alphaName, key: item.abnumber, ...item })
    );
    setVendorDropdownList(list);
  }, [vendorDetails])

  const filterOptionVendor = (value: any, action: any) => {
    if (action.action === "input-change") {
      setVendorSearchText(value)
    }
  };

  useEffect(() => {
    if (vendorSearchText?.length > 2) {
      dispatch(getVendorDetails(vendorSearchText.replace(/[^\w\s]/gi, "")));
    } else {
      dispatch(getVendorDetails(''))
    }
  }, [vendorSearchText])

  const dealerSelectOnBlur = () => {
    setVendorSearchText('')
  }

  const purchaseitemDetails = (val: any, item: any) => {
    const purchaseOrderData = {
      vendorAbNumber: item?.abnumber,
      vendorName: item?.alphaName,
      vendorAdd1: item?.address1,
      vendorAdd2: item?.address2,
      vendorAdd3: item?.address3,
      vendorState: item?.state,
      vendorCity: item?.city,
      vendorZip: item?.postalCode,
      vendorPhone: item?.phoneAreaCode + item?.phoneNumber,
      vendorContactEmail: val?.vendorDetails?.dealerContactEmail
    };
    return purchaseOrderData;
  }

  const onChangeVendorName = (item: any) => {
    setVendor(item)
    setVendorSearchText('')
    const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
    bulkOrderFleetDetailsTemp?.map((detailItem?: any) => {
      if (detailItem?.orderDetailId == purchaseOrderStepperData?.orderDetailId) {
        detailItem.vendorDetails = purchaseitemDetails(detailItem, item)
        detailItem.isVendorChanged = true
      }
    })
    dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp))
    let changedVendorDetails = bulkOrderFleetDetailsTemp?.find((orderItem?: any) => orderItem?.orderDetailId == purchaseOrderStepperData?.orderDetailId)
    let isValidVendorDetails = hasValidVendorDetails(changedVendorDetails ?? {})
    if (isValidVendorDetails) {
      setIsButtondisable(false);
    }else{
      setIsButtondisable(true);
    }
  }

  const handleChange = (event: any, items?: any) => {
    const name = event.target.name;
    const value = name == "vendorPhone" ? items : event.target.value;
    if (name == "vendorZip" && value) {
      const regEx = /^\d{0,12}(\.\d{1,4})?$/;
      const valArr = value.split('.')
      const checkNumber = regEx.test(value);
      if (!checkNumber || valArr.length > 1) {
          return;
      }
  }
    if (name == "vendorAbNumber" || name == "vendorName" || name == "vendorAdd1" || name == "vendorAdd2" || name == "vendorState" || name == "vendorCity" || name == "vendorZip" || name == "vendorContactEmail" || name == "vendorPhone") {
      const bulkOrderFleetDetailsTemp: any = bulkOrderFleetDetails ? JSON.parse(JSON.stringify(bulkOrderFleetDetails)) : []
      bulkOrderFleetDetailsTemp?.map((item?: any) => {
        if (item?.orderDetailId == purchaseOrderStepperData?.orderDetailId) {
          item.vendorDetails = {
            ...item?.vendorDetails,
            [name]: value,
            ['is' + name + 'Changed'] : true
          }
          item.isVendorChanged = true
        }
      })
      dispatch(setBulkOrderFleetHeader(bulkOrderFleetDetailsTemp));
    let changedVendorDetails = bulkOrderFleetDetailsTemp?.find((orderItem?: any) => orderItem?.orderDetailId == purchaseOrderStepperData?.orderDetailId)
    let isValidVendorDetails = hasValidVendorDetails(changedVendorDetails ?? {})
    if (isValidVendorDetails) {
      setIsButtondisable(false);
    }else{
      setIsButtondisable(true);
    }
    }
  };

  return (
    <VendorDetail
      vendorDropdownList={vendorDropdownList}
      filterOptionVendor={filterOptionVendor}
      dealerSelectOnBlur={dealerSelectOnBlur}
      vendorSearchText={vendorSearchText}
      onChangeVendorName={onChangeVendorName}
      vendor={vendor}
      purchaseOrderStepperData={purchaseOrderStepperData}
      handleChange={handleChange}
      errors={errors}
      isNextClicked = {isNextClicked}
    />
  )
}

export default VendorDetailContainer